import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import SectionTitle from './SectionTitle';

const {FiSearch,FiLink,FiSend,FiArrowUpRight}=FiIcons;

const steps=[
  {number: '01',icon: FiSearch,title: 'Find their business',description: 'Open the review-link tool,search for the business by name and location,and select its Google listing.'},
  {number: '02',icon: FiLink,title: 'Create a free link',description: 'Select “Generate free review link.” The business gets its own page,where the owner can copy the customer-facing review link or download a QR code.'},
  {number: '03',icon: FiSend,title: 'Use it to start a conversation',description: 'Show the owner the page,explain how they can share the link by text or QR code,and ask how they currently request and respond to reviews.'}
];

export default function ReviewLinkGuide() {
  return (
    <section>
      <SectionTitle eyebrow="Free review-link tool" title="Lead with something useful.">
        Give a local business a practical way to share its review page,then use the conversation to learn where it needs marketing help.
      </SectionTitle>
      <div className="mt-8 flex flex-col gap-5 rounded-3xl bg-[#0b1423] p-6 text-white sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#a7e2be]">Your first move</p>
          <h3 className="mt-2 text-xl font-black sm:text-2xl">Make a link while you’re talking.</h3>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-300">
            It’s a simple,no-cost way to demonstrate value before discussing Local Momentum.
          </p>
        </div>
        <Link to="/reviews" className="site-button inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-full px-6 py-4 font-bold sm:w-auto">
          Open review-link tool <SafeIcon icon={FiArrowUpRight} />
        </Link>
      </div>
      <div className="mt-8 grid gap-4 md:grid-cols-3">
        {steps.map((step)=> (
          <article key={step.number} className="rounded-3xl border border-slate-200 bg-slate-50 p-6">
            <div className="flex items-center justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#e0f5ff] text-[#0b1423]">
                <SafeIcon icon={step.icon} className="h-6 w-6" />
              </span>
              <span className="text-sm font-black text-slate-400">{step.number}</span>
            </div>
            <h3 className="mt-7 text-xl font-black">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{step.description}</p>
          </article>
        ))}
      </div>
      <div className="mt-8 rounded-3xl border border-[#a7e2be] bg-[#effaf2] p-6 sm:p-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#176445]">Conversation starter</p>
        <p className="mt-3 text-lg font-semibold leading-relaxed">
          “I made a free review link for your business. Would it be helpful if I showed you how to share it with customers?”
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-600">
          If they’re interested,ask what they do today to stay visible on Google. Listen first;then explain how Jelly Local can help with their wider local presence.
        </p>
      </div>
    </section>
  );
}